<template>
  <gj-select
      v-bind="$attrs"
      v-on="$listeners"
      :options="active ? activeSupplier : supplier"
      :placeholder="placeholder"
      :type="multiple ? 'multi-check' : 'default'"
  ></gj-select>
</template>

<script>
  import {mapGetters} from "vuex";
  import {PURCHASE_GET_ACTIVE_SUPPLIER, PURCHASE_GET_SUPPLIER} from "../../store/action-types";
  export default {
    name: "gj-supplier-select",
    computed: {
      ...mapGetters({
        supplier: 'supplier',
        activeSupplier: 'activeSupplier',
      }),
    },
    props: {
      active: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: '供应商资料'
      }
    },
    created() {
      if (this.active) {
        if (this._.isEmpty(this.activeSupplier)) {
          this.$store.dispatch(PURCHASE_GET_ACTIVE_SUPPLIER);
        }
      } else {
        if (this._.isEmpty(this.supplier)) {
          this.$store.dispatch(PURCHASE_GET_SUPPLIER);
        }
      }
    }
  }
</script>

<style scoped>

</style>
